module.exports = __webpack_public_path__ + "static/media/commsgroup-alt-logo 2.7ac4c717.png";